import { render, staticRenderFns } from "./index.vue?vue&type=template&id=69dfa632&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dfa632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69dfa632')) {
      api.createRecord('69dfa632', component.options)
    } else {
      api.reload('69dfa632', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=69dfa632&scoped=true", function () {
      api.rerender('69dfa632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchant/collateUser/index.vue"
export default component.exports